import { createContext, useContext } from 'react';

export const context = createContext<{ isEmbedded?: boolean }>({});

export function useMountContext() {
    return useContext(context);
}
